module.exports = __webpack_public_path__ + "img/geod_16.e37aec11.jpg";